export const performance: Performance = process.server ? require('perf_hooks').performance : window.performance
